import React, { useState } from 'react';

export default function LandingPage({ onLogin }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [apiKey, setApiKey] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerifyApiKey = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(
        `http://192.168.52.172:8088/ApiDocAndSandbox/api/Auth/GetAuthUser?key=${apiKey}`,
        { method: 'GET', redirect: 'follow' }
      );
      const result = await response.json();
      if (result.responseCode === '00') {
        onLogin(apiKey);
      } else {
        setError(result.responseMessage || 'Invalid Access key.');
      }
    } catch (err) {
      setError('Failed to verify Access key. Please try again.');
      console.error('Verify error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      fullname: fullName,
      emailAddress: email,
      phoneNumber: phone,
    };

    try {
      const response = await fetch(
        'http://192.168.52.172:8088/ApiDocAndSandbox/api/Auth/AuthUser',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          redirect: 'follow',
        }
      );
      const result = await response.json();
      if (result.responseCode === '00') {
        setApiKey(result.responseData);
        setIsRegistering(false);
        onLogin(result.responseData);
      } else {
        setError(result.responseMessage || 'Registration failed.');
      }
    } catch (err) {
      setError('Failed to register. Please try again.');
      console.error('Register error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4 overflow-hidden">
      <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-200 max-w-sm w-full transform transition-all duration-300 hover:shadow-2xl">
        <div className="text-center mb-6">
          <div className="w-12 h-12 bg-[#fdb814] rounded-full mx-auto mb-3 flex items-center justify-center">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-gray-800 mb-1">
            Providus API Sandbox
          </h1>
          <p className="text-xs text-gray-500">Test and explore APIs seamlessly</p>
        </div>
        {isRegistering ? (
          <form onSubmit={handleRegister} className="space-y-4">
            <div className="space-y-3">
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Full Name"
                className="w-full p-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fdb814] focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                required
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                className="w-full p-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fdb814] focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                required
              />
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone Number"
                className="w-full p-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fdb814] focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                required
              />
            </div>
            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                <p className="text-red-600 text-xs flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {error}
                </p>
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 text-sm font-semibold bg-gradient-to-r from-[#fdb814] to-[#e5a50f] text-white rounded-lg hover:from-[#e5a50f] hover:to-[#d4940a] disabled:from-orange-300 disabled:to-orange-400 disabled:cursor-not-allowed transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30"
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Registering...
                </div>
              ) : 'Create Account'}
            </button>
            <div className="text-center">
              <p className="text-xs text-gray-600">
                Already have an Access key?{' '}
                <button
                  type="button"
                  className="text-[#fdb814] hover:text-[#e5a50f] font-semibold transition-all duration-200 hover:underline underline-offset-2 decoration-2 decoration-[#fdb814] hover:decoration-[#e5a50f]"
                  onClick={() => setIsRegistering(false)}
                >
                  Sign in here
                </button>
              </p>
            </div>
          </form>
        ) : (
          <form onSubmit={handleVerifyApiKey} className="space-y-4">
            <div className="relative">
              <input
                type="text"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Enter your Access Key"
                className="w-full p-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#fdb814] focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
                required
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m0 0a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9a2 2 0 012-2m0 0V7a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
            </div>
            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                <p className="text-red-600 text-xs flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {error}
                </p>
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 text-sm font-semibold bg-gradient-to-r from-[#fdb814] to-[#e5a50f] text-white rounded-lg hover:from-[#e5a50f] hover:to-[#d4940a] disabled:from-orange-300 disabled:to-orange-400 disabled:cursor-not-allowed transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30"
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Verifying...
                </div>
              ) : 'Access Sandbox'}
            </button>
            <div className="text-center">
              <p className="text-xs text-gray-600">
                Don't have an Access key?{' '}
                <button
                  type="button"
                  className="text-[#fdb814] hover:text-[#e5a50f] font-semibold transition-all duration-200 hover:underline underline-offset-2 decoration-2 decoration-[#fdb814] hover:decoration-[#e5a50f]"
                  onClick={() => setIsRegistering(true)}
                >
                  Get your Access key here
                </button>
              </p>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}